
import React from "react";
import { OperationProvider, useOperation } from "../Context/OperationContext";
import MiningOperation from "./Operations/MiningOperation";
import GlobalOperation from "./Operations/GlobalOperation";

const OperationContent = () => {
  const { miningSite } = useOperation();

  if (miningSite) {
    return <MiningOperation />;
  }

  return <GlobalOperation />;
};

const Operation = () => {
  return (
    <OperationProvider>
      <OperationContent />
    </OperationProvider>
  );
};

export default Operation;
